// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__AvCCy","ranges":"BmiRanges_ranges__3hir5"};